export enum SessionStorageConstants {
  ADMIN_TASKS_FILTERS = "AdminTasks.Filters",
  ADMIN_TASKS_SORT_DATA = "AdminTasks.SortData",
  ADMIN_TASKS_SELECTED_TAB = "AdminTasks.SelectedTab",
  TENANT_EXTERNAL_ID = "tenantExternalId",
  BYPASS_NOT_SUPPORTED = "BypassNotSupported",
  CHUNK_RELOAD_AT = "ChunkLoad.ReloadAt",
}
